<div class="container my-5">
    <h1>User Agreement</h1>
    
    <h2>Welcome to ChessX.ai</h2>
    <p>By accessing and using our website, you agree to comply with the following terms and conditions. Please read them carefully.</p>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>1. Introduction</h3>
      </div>
      <div class="card-body">
        <p><strong>1.1 Purpose:</strong> This User Agreement ("Agreement") sets forth the terms and conditions under which you may access and use ChessX.ai ("Website").</p>
        <p><strong>1.2 Acceptance:</strong> By accessing or using the Website, you agree to be bound by this Agreement.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>2. User Responsibilities</h3>
      </div>
      <div class="card-body">
        <p><strong>2.1 Account Creation:</strong> You must provide accurate information when creating an account and keep your account information up-to-date.</p>
        <p><strong>2.2 Account Security:</strong> You are responsible for maintaining the confidentiality of your account and password.</p>
        <p><strong>2.3 Prohibited Activities:</strong> You agree not to engage in activities such as cheating, spamming, harassment, or any other activity that violates this Agreement.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>3. Use of Services</h3>
      </div>
      <div class="card-body">
        <p><strong>3.1 Playing with the Computer:</strong> Users must follow the rules and guidelines when playing against the computer.</p>
        <p><strong>3.2 Watching Tournament Matches:</strong> Users can watch tournament matches but must adhere to the guidelines provided.</p>
        <p><strong>3.3 Puzzles:</strong> Puzzles are provided for educational and entertainment purposes. Users must not exploit or misuse this feature.</p>
        <p><strong>3.4 Viewing Played Game Data:</strong> Users can access and use game data in accordance with the rules set forth by ChessX.ai.</p>
        <p><strong>3.5 Leaderboard:</strong> The leaderboard reflects fair play. Any form of manipulation or cheating is strictly prohibited.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>4. Intellectual Property Rights</h3>
      </div>
      <div class="card-body">
        <p><strong>4.1 Ownership:</strong> ChessX.ai owns all content, design, and features of the Website.</p>
        <p><strong>4.2 User-Generated Content:</strong> By submitting content to ChessX.ai, you grant us a non-exclusive, royalty-free license to use, modify, and distribute your content.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>5. Privacy</h3>
      </div>
      <div class="card-body">
        <p><strong>5.1 Data Collection:</strong> We collect and use your data in accordance with our Privacy Policy.</p>
        <p><strong>5.2 Cookies:</strong> We use cookies and other tracking technologies to enhance your experience.</p>
        <p><strong>5.3 User Rights:</strong> You have rights regarding your personal data as detailed in our Privacy Policy.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>6. Limitation of Liability</h3>
      </div>
      <div class="card-body">
        <p><strong>6.1 No Warranty:</strong> The services are provided "as is" without any warranties.</p>
        <p><strong>6.2 Liability Cap:</strong> ChessX.ai's liability is limited to the maximum extent permitted by law.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>7. Termination</h3>
      </div>
      <div class="card-body">
        <p><strong>7.1 Grounds for Termination:</strong> ChessX.ai may terminate your account for violations of this Agreement.</p>
        <p><strong>7.2 Process:</strong> We will notify you of the termination and provide instructions for any appeal process.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>8. Changes to the Agreement</h3>
      </div>
      <div class="card-body">
        <p><strong>8.1 Modification Rights:</strong> We reserve the right to modify this Agreement at any time.</p>
        <p><strong>8.2 Notification:</strong> We will notify you of any changes through the Website or via email.</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>9. Governing Law</h3>
      </div>
      <div class="card-body">
        <p><strong>9.1 Jurisdiction:</strong> This Agreement is governed by the laws of [Your Jurisdiction].</p>
      </div>
    </div>
  
    <div class="card mb-3">
      <div class="card-header">
        <h3>10. Contact Information</h3>
      </div>
      <div class="card-body">
        <p><strong>10.1 Support:</strong> For support or inquiries, please contact us at [Support Email].</p>
      </div>
    </div>
  </div>
  